


















import showBindPhone from "@ivy/fts/showBindPhone"
import { Component, Vue, Prop } from "vue-property-decorator"
@Component
export default class IndexHeader extends Vue {
  @Prop() auth: boolean
  loginInfo: any = {}
  isShow: boolean = true
  showUser: boolean = true
  timer: any
  async mounted() {
    this.loginInfo = (await this.$store.login()) || {}
    this.timer = setTimeout(() => {
      this.isShow = false
    }, 4000)
  }
  isShowFun() {
    this.timer && clearTimeout(this.timer)
    this.showUser = false
    this.isShow = !this.isShow
  }
  async bindPhoneRegister() {
    if (this.loginInfo.token) return
    let logined = await showBindPhone(this.$store.bindPhoneOptions)
    logined && this.$router.go(0)
  }
  toCenter() {
    window.location.href = `${window.location.origin}/center/index/myPage`
  }
}
